export interface ModalState {
    currentlyOpenModalData: ModalData<any>;
}

export interface ModalData<T> {
    name: string;
    data: T;
}

export const InitialModalState: ModalState = {
    currentlyOpenModalData: null,
};

export interface OpenModalPayload {
    modalId: string;
    modalData?: any;
}
